var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWebDevelopers(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "blog_post",
    "data-name": "blog post",
    width: 40,
    height: 40,
    transform: "translate(1110 1574)",
    fill: "rgba(0,0,0,0.13)"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_95829",
    "data-name": "Mask Group 95829",
    transform: "translate(-1110 -1574)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_172078",
    "data-name": "Group 172078",
    transform: "translate(1117 1581)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_172077",
    "data-name": "Group 172077"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_172075",
    "data-name": "Group 172075",
    transform: "translate(5.514)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_172106",
    "data-name": "Path 172106",
    d: "M10.887,1.6a5.19,5.19,0,1,0,5.19,5.19A5.187,5.187,0,0,0,10.887,1.6Z",
    transform: "translate(-5.71 -1.6)",
    fill: "#E39DFF"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_172076",
    "data-name": "Group 172076",
    transform: "translate(0 10.717)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_172107",
    "data-name": "Path 172107",
    d: "M15.959,10.307a11.746,11.746,0,0,0-1.152-.337l-.362-.091-.324.194a4.011,4.011,0,0,1-3.948,0L9.85,9.88l-.375.091A11.529,11.529,0,0,0,1.709,16.2l-.259.531.375.466a13.2,13.2,0,0,0,10.316,4.931c.311,0,.634-.013.945-.039a8.449,8.449,0,0,1,2.873-11.778Z",
    transform: "translate(-1.45 -9.88)",
    fill: "#E39DFF"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_172108",
    "data-name": "Path 172108",
    d: "M17.624,10.29a7.184,7.184,0,1,0,7.184,7.184A7.192,7.192,0,0,0,17.624,10.29Zm-2.058,8.1a.641.641,0,0,1,0,.919.65.65,0,0,1-.453.194.628.628,0,0,1-.453-.194l-1.346-1.346a.641.641,0,0,1,0-.919L14.66,15.7a.65.65,0,1,1,.919.919l-.893.893ZM18.931,15.3,17.585,20.01a.637.637,0,0,1-.621.466,1.015,1.015,0,0,1-.181-.026.638.638,0,0,1-.44-.8l1.346-4.711a.638.638,0,0,1,.8-.44A.659.659,0,0,1,18.931,15.3Zm3.055,2.653L20.639,19.3a.65.65,0,0,1-.453.194.628.628,0,0,1-.453-.194.641.641,0,0,1,0-.919l.893-.893-.893-.893a.65.65,0,0,1,.919-.919L22,17.021A.694.694,0,0,1,21.985,17.952Z",
    transform: "translate(1.196 0.958)",
    fill: "#E39DFF"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWebDevelopers);
export default __webpack_public_path__ + "static/media/web_developers.4e3d893adf1ab0b755a9e88352430538.svg";
export { ForwardRef as ReactComponent };